import { render, staticRenderFns } from "./Calculators.vue?vue&type=template&id=747b9395&scoped=true&"
import script from "./Calculators.vue?vue&type=script&lang=ts&"
export * from "./Calculators.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "747b9395",
  null
  
)

export default component.exports